<template>
    <div>
        <MedicineTransactionTable />
    </div>
</template>

<script>
import MedicineTransactionTable from '@/components/medicine/MedicineTransactionTable.vue'
export default {
    components: {
        MedicineTransactionTable
    },
    name: 'MedicineTransactions'
}
</script>